/**
 * Module dependencies.
 */

import { SubTitle } from 'components/atoms/sub-title/sub-title';
import { color } from 'styles/utils/colors';
import styled from '@emotion/styled';

/**
 * Export `StyledSubTitle` styled component.
 */

export const StyledSubTitle = styled(SubTitle)`
  color: ${color('primary400')};
  margin: 0 auto;
  text-align: center;
  margin-top: 32px;
  margin-bottom: 16px;
  font-weight: 100;
  font-size: 30px;
`;
